export default __webpack_public_path__ + "locales/tr/FilesSettings.json?hash=c58c5c6295472c9790387c26f9d4d48c";